import { ClearEditorPlugin } from '@lexical/react/LexicalClearEditorPlugin';
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
import PropTypes from 'prop-types';

import { isBrowser } from 'lib/utils';

import EmojiPlugin from './EmojiPlugin';
import ImagePlugin from './ImagePlugin';
import LinkPlugin from './LinkPlugin';
import MentionsPlugin from './MentionPlugin';
import OnChangePlugin from './OnChangePlugin';
import VideoPlugin from './VideoPlugin';

const Plugins = ({ onChange }) => (
  <>
    <ClearEditorPlugin />
    <EmojiPlugin />
    <HistoryPlugin />
    <ImagePlugin />
    <LinkPlugin />
    {isBrowser() && <MentionsPlugin />}
    {onChange && <OnChangePlugin onChange={onChange} />}
    <VideoPlugin />
  </>
);

Plugins.propTypes = {
  onChange: PropTypes.func,
};

export default Plugins;
